export const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1px solid #2a5e38" : "1px solid #E0E0E0",
    padding: "5px",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "19.12px",
    width: "100%",
    minHeight: "auto",
    boxShadow: "none",
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      borderColor: "#2a5e38",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    marginTop: "5px",
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
    backgroundColor: state.isSelected
      ? "#2a5e38"
      : state.isFocused
      ? "#e6f2ea"
      : "white",
    color: state.isSelected ? "white" : "#333",
    cursor: "pointer",
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      backgroundColor: state.isSelected ? "#2a5e38" : "#e6f2ea",
      color: state.isSelected ? "white" : "#333",
    },
    "&:active": {
      backgroundColor: "#e6f2ea",
    },
  }),
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: "#E0E0E0",
    borderRadius: "5px",
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    fontSize: "12px",
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    color: "#666",
    ":hover": {
      backgroundColor: "#ccc",
      color: "#333",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#666",
    "&:hover": {
      color: "#333",
    },
  }),
};
